import { render } from "./HelpView.vue?vue&type=template&id=3cf37e28&scoped=true"
import script from "./HelpView.vue?vue&type=script&lang=js"
export * from "./HelpView.vue?vue&type=script&lang=js"

import "./HelpView.vue?vue&type=style&index=0&id=3cf37e28&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cf37e28"]])

export default __exports__